'use client';

import { useStore } from '@base-ui/utils/store';
import { useSchedulerStoreContext } from "../../use-scheduler-store-context/useSchedulerStoreContext.mjs";
import { schedulerOccurrenceSelectors, schedulerOtherSelectors } from "../../scheduler-selectors/index.mjs";
export function useEvent(parameters) {
  const {
    start,
    end,
    eventId
  } = parameters;
  const store = useSchedulerStoreContext();
  const started = useStore(store, schedulerOccurrenceSelectors.isStarted, start);
  const ended = useStore(store, schedulerOccurrenceSelectors.isEnded, end);
  const editing = useStore(store, schedulerOtherSelectors.isEditedEvent, eventId);
  return {
    state: {
      started,
      ended,
      editing
    }
  };
}